import { render, staticRenderFns } from "./ActiveGameDetailsModal.vue?vue&type=template&id=0736b238&"
import script from "./ActiveGameDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ActiveGameDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports